export const CREATE_INCREMENT = "CREATE_INCREMENT";
export const FETCH_INCREMENTS = "FETCH_INCREMENTS";
export const FETCH_INCREMENT = "FETCH_INCREMENT";
export const EDIT_INCREMENT = "EDIT_INCREMENT";
export const DELETE_INCREMENT = "DELETE_INCREMENT";
